import qs from 'qs'
import axios from 'axios'

import {
	mapActions,
	mapMutations
} from 'vuex'

import {
	Modal,
	Input,
	DIV,
	Switch
} from 'iview'

export default {
	data() {
		return {
			isShow: false
		}
	},
	methods: {
		...mapActions([
			'getsAvatar',

		]),
		setImg(path, fileFormat) { //色调  0：蓝色    1：绿色   2：橙色    3：红色
			if (this.$store.state.user.subjectColor.hue == 1) {
				return require('@/assets/img/' + path + 'Green.' + fileFormat)
			} else if (this.$store.state.user.subjectColor.hue == 2) {
				return require('@/assets/img/' + path + 'Orange.' + fileFormat)
			} else if (this.$store.state.user.subjectColor.hue == 3) {
				return require('@/assets/img/' + path + 'Red.' + fileFormat)
			} else {
				return require('@/assets/img/' + path + 'Blue.' + fileFormat)
			}
		},
		getInfo(setupType, groupId) {
			this.$Spin.show();
			this.$post(this.domain.dataRealization + 'pageSetup/getPageSetup', qs.stringify({
					channelCode: window.channel,
					setupType: setupType,
					groupId: groupId ? groupId : ''
				}))
				.then((res) => {
					var this_ = this
					this.pageSetup = JSON.parse(res.data.content.setupContent)


					// setTimeout(function(){
					this_.isShow = true
					this_.$Spin.hide();
					// },3000)

				});
		},
		openPdf(url) { //打开pdf
			window.open(url)
		},
		hexToRgb(hex, a) {
			// 去除 # 符号
			var color = hex.replace("#", "");

			// 分割 RGB 三原色部分
			var r = parseInt(color.substring(0, 2), 16);
			var g = parseInt(color.substring(2, 4), 16);
			var b = parseInt(color.substring(4, 6), 16);

			return `rgba(${r}, ${g}, ${b},${a})`;
		},
		handleMaxSize(file) {
			this.$Message.warning('上传的图片不能超过2M')
		},
		setUpAvatar(res) { //更改头像
			const headPortrait = this.domain.testUrl + this.domain.dataRealization + res.content.url
			this.getsAvatar({
				headPortrait
			})

			this.saveHeaderImg(res.content.url)
		},
		saveHeaderImg(imgPath) { //保存头像
			this.$post(this.domain.dataRealization + 'dataCustomer/saveHeaderImg', qs.stringify({
					headerImg: imgPath
				}))
				.then((res) => {

				});
		},
		getCaptcha(value) { //发送短信验证码
			const phone = value.trim()
			if (phone) {
				// 获取验证码
				this.$post(this.domain.dataRealization + 'secure/sendPhoneCodSecure', qs.stringify({
						phoneNum: value
					}))
					.then((res) => {
						res = res.data
						if (res.code == 200) {
							this.cooling = 60
							let coolingInter = setInterval(() => {
								if (this.cooling > 0) {
									this.cooling--
								} else {
									clearInterval(coolingInter)
								}
							}, 1000)
							// const xPhone = phone.slice(0, 3) + 'xxxx' + phone.slice(7)
							// this.$Notice.success({
							// 	title: '验证码',
							// 	desc: `验证码已发送至${xPhone}`,
							// 	duration: 5
							// })
						} else {
							this.$Message.error(res.message)
						}
					});
			} else {
				this.$Message.warning('请输入手机号')
			}

		},
		alert(text, empty, key) {
			Modal.warning({
				title: '提示',
				content: text,
				onOk: () => {
					if (empty) {
						this.authInfo[key] = ''
					}
					console.log('确认按钮被点击');
				}
			});
		},
		handleMaxSize(file) {
			this.$Message.warning('上传的图片不能超过2M')
		},
		upLogo(res, key) {
			this.data[key] = this.domain.testUrl + this.domain.dataRealization + res.content.url
		},
		escapeRegExp: function(string) { //转义特殊字符
			return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
		},
		fuzzyQuery() {
			var this_ = this;
			var text = this_.escapeRegExp(this_.companyName);
			var regex = new RegExp(text)
			if (/^[\u4e00-\u9fa5]+$/.test(this_.companyName)) {
				clearTimeout(this_.inputTimer);
				this_.inputTimer = setTimeout(function() { //阻止input方法执行两次
					if (this_.companyName.length >= 4 && this_.companyName.length < 20) {
						console.log('中文输入已完成,调模糊查询')
						this_.getCompanyName(this_.companyName)
					}
				}, 100); // 设置一个适当的延迟时间

			} else {
				// 中文输入未完成
				if (this_.companyName.length == 0) {
					this_.getCompanyNameList = []
				}
			}
		},
		getCompanyName: function(name) {
			this.getCompanyNameList = []
			this.$post(this.domain.ajaxUrl + 'baseInfo/getCompanyName', qs.stringify({
					companyName: name
				}))
				.then((res) => {
					// this.getCompanyNameList = res.data.content
					res.data.content.map(el => {
						this.getCompanyNameList.push(el)
					})
				});
		},
		checkedName(name, base) {
			console.log('点击了公司列表')
			this.companyName = name
			$('#getCompanyNameList').html('');
		},
		creatIndustry(companyName) {
			var productUrl = this.setLocation('', '99')
			sessionStorage.generatebpName = companyName
			window.location.href = window.domainName + productUrl + '#/industry'

		},
		loadResources() {
			this.resources.forEach(resource => {
				if (resource.type === 'css') {
					this.loadCSS(this.domain.testUrl + resource.href);
					// this.loadCSS('http://127.0.0.1:5500/' + resource.href);
				} else if (resource.type === 'js') {
					this.loadJS(this.domain.testUrl + resource.src);
					// this.loadJS('http://127.0.0.1:5500/' + resource.src);
				}
			});
		},
		loadResources_(data) {
			data.forEach(resource => {
				if (resource.type === 'css') {
					this.loadCSS(resource.href);
				} else if (resource.type === 'js') {
					this.loadJS(resource.src);
				}
			});
		},
		loadCSS(href) {
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = href;
			link.onload = () => {
				// console.log(`CSS loaded: ${href}`);
			};
			link.onerror = () => {
				console.error(`Failed to load CSS: ${href}`);
			};
			document.head.appendChild(link);
		},
		loadJS(src) {
			const script = document.createElement('script');
			script.src = src;
			// script.async = true;
			script.onload = () => {
				// console.log(`Script loaded: ${src}`);
				// 在这里可以调用该库提供的功能
			};
			script.onerror = () => {
				console.error(`Failed to load script: ${src}`);
			};
			document.body.appendChild(script);
		},
		productEntrance(stage, type) {
			var productUrl = this.setLocation(stage, type)

			if (stage == 2 && type == 2) {
				var path = 'growthValuationBasic'
			} else if (stage == 3 && type == 2) {
				var path = 'maturityValuationBasic'
			} else if (stage == 2 && type == 1) {
				var path = 'growthValuationBasicFast'
			} else if (stage == 3 && type == 1) {
				var path = 'maturityValuationBasicFast'
			} else if (stage == 2 && type == 7) {
				var path = "growthDiagnosisBasic";
			} else if (stage == 3 && type == 7) {
				var path = "maturityDiagnosisBasic";
			} else if (stage == 1) {
				var path = type == 7 ? "initialDiagnosisBasic" : "initialValuationBasic";
			} else if (type == 13) {
				var path = "dataValuationInfo";
			} else if (type == 14) {
				var path = "basicInformationEvaluation";
			} else if (type == 15) {
				var path = "dataValuationInfoFast";
			} else if (type == 11) {
				var path = "earlyWarningBasic";
			} else if (type == 100) {
				var path = "surveyBasic";
			} else if (type == 98) {
				var path = "fixPrice";
			} else if (stage == 4) {
				var path = "mergerBasic";
			} else if (type == 16) {
				var path = 'fpvBase';
			} else if (stage == 7 && type == 2) {
				var path = 'dvBasic';
			} else if (stage == 7 && type == 7) {
				var path = 'ddxBasic';
			} else if (stage == 8 && type == 2) {
				var path = 'agriEVBasic';
			} else if (stage == 8 && type == 7) {
				var path = 'agriDiagBasic';
			}


			window.location.href = window.domainName + productUrl + '#/' + path


		},
		setLocation(stage, type) {
			let str = ''
			if (type == 2) {
				str = stage == 7 ? 'darwinValuation/' : stage == 8 ? 'agriEV/' : 'proValuation/'
			} else if (type == 1) {
				str = 'fast/'
			} else if ((stage == 2 && type == 7) || (stage == 3 && type == 7)) {
				str = 'prodiagnosis/'
			} else if (stage == 1) {
				str = type == 7 ? 'startdiagnosis/' : 'startValuation/'
			} else if (type == 13) {
				str = 'dataProfessional/'
			} else if (type == 14 || type == 15) {
				str = 'dataValuation/'
			} else if (type == 99) {
				str = 'pptist/'
			} else if (type == 11) {
				str = 'earlyWarning/'
			} else if (type == 100) {
				str = 'Survey/'
			} else if (type == 98) {
				str = 'dataPricing/'
			} else if (stage == 4) {
				str = 'merge/'
			} else if (type == 16) {
				str = 'fpv/'
			} else if (stage == 7 && type == 7) {
				str = 'ddx/'
			} else if (stage == 8 && type == 7) {
				str = 'agriDiag/'
			}


			return str
		},
		valuationDesHtml(stage, type) { //项目估值的产品描述
			var str = ''
			if (stage == 1) {
				str = `<p class="description">基本情况分析 / 收入明细预测 / 融资案例匹配企业风险比对 / 估值原理说明 / 未来成本规划</p>`
			} else if (stage == 2 || stage == 3) {
				str = `<p class="description">完整的财务预测 / 可比公司分析 / 公司基本情况概览 / 专业估值诊断和建议 / 相对绝对估值法相结合</p>`
			} else if (stage == 4) {
				str = `<p class="description">先例交易智能匹配 / 并购双方综合画像 / 流动性风险量化处理 / 控股权溢价科学评估</p>`
			} else if (stage == 7) {
				str = `<p class="description">经营能力分析 / 企业多维评价 / 估值建议 / 多种估值模型 / 未来年度业绩及财务预测</p>`
			} else if (type == 13) {
				str = `<p class="description">收益贡献法 / 机器深度学习估值法 / 评价指标多维度综合分析 / 数据资产未来预期收益 / 层次分析法判断数据资产贡献程度</p>`
			} else if (type == 14) {
				str = `<p class="description">基础指标 / 质量指标 / 经济指标 / 风险指标 / 成本指标 / 流通指标 / 科学计量分析 / 量化建模/ 选择不同的分析方法和模型</p>`
			} else if (type == 15) {
				str = `<p class="description">科学的评价指标多维度综合分析 / 机器深度学习估值法 / 层次分析法判断数据资产贡献程度</p>`
			} else if (type == 98) {
				str = `<p class="description">综合考虑数据成本 / 应用场景 / 同类产品 / 市场需求 / 对数据产品的价格进行精准计算</p>`
			} else if (type == 11) {
				str = `<div class="earlyWarningDes">
								<p>
									<i class="iconfont icon-fuxuankuang"></i>
									<span>识别财务风险 ，财务状况进行实时监控</span>
								</p>
								<p>
									<i class="iconfont icon-fuxuankuang"></i>
									<span>提供决策依据，提高经营效率和市场竞争力</span>
								</p>
								<p>
									<i class="iconfont icon-fuxuankuang"></i>
									<span>监控财务状况， 改进经营管理</span>
								</p>
								<p>
									<i class="iconfont icon-fuxuankuang"></i>
									<span>提升企业价值，持续监测和改进</span>
								</p>
							</div>`
			} else if (type == 100) {
				str = `<div class="dueDiligenceDes">
								<p>
									<i class="iconfont icon-fuxuankuang"></i>
									<span>全方位梳理企业业务、财务、法务状况</span>
								</p>
								<div>
									<span>企业概况调查</span>
									<span>管理尽职调查</span>
									<span>法务概况调查</span>
									<span>财务尽职调查</span>
									<span>业务尽职调查</span>
								</div>
							</div>`
			} else if (type == 16) {
				str = `<div class="description">
								<p>
									<i class="iconfont icon-icon--yes"></i>
									<span>自动化估值、简化工作流程、提升决策效率，助力合规运营。</span>
								</p>
								<p>
									<i class="iconfont icon-icon--yes"></i>
									<span>随时掌握基金业绩动态，为后续投资决策提供有力依据，保护投资利益。</span>
								</p>
								<p>
									<i class="iconfont icon-icon--yes"></i>
									<span>减轻工作负担，快速生成标准化估值报告，降低人力成本，提升服务质量。</span>
								</p>
							</div>`
			} else if (stage == 5 && type == 9) {
				str = `<div class="description">
								<p>
									<i class="iconfont icon-icon--yes"></i>
									<span>从基金的募资表现、投资表现、管理表现、退出表现、合作表现及履约能力等方面进行多维度剖析。</span>
								</p>
								<p>
									<i class="iconfont icon-icon--yes"></i>
									<span>投资项目数据化展示及分析，一目了然。</span>
								</p>
							</div>`
			} else if (stage == 5 && type == 10) {
				str = `<div class="description">
								<p>
									<i class="iconfont icon-icon--yes"></i>
									<span>从基金的募投管退、合作及履约等方面进行科学有效的量化评价。</span>
								</p>
								<p>
									<i class="iconfont icon-icon--yes"></i>
									<span>运用七维价值模型，生成专业、全面、客观、公允的智能化基金估值。</span>
								</p>
							</div>`
			} else if (stage == 8) {
				str = `<p class="description">深耕农业多维度指标 / 预警潜在风险 / 专业算法量化农业企业价值</p>`
			}


			return str
		},
		fundsDesHtml(stage, type) {
			let str = ''
			if (type == 16) {
				str = `<p class="description">科学的评价指标多维度综合分析 / 机器深度学习估值法 / 层次分析法判断数据资产贡献程度</p>`
			} else if (stage == 5 && type == 9) {
				str = `<p class="description">基金基本概况 / 七维评价指标 / 可视化解析 / 科学的评价体系 / 投资项目全方位图标解析 / 一键生成报告</p>`
			} else if (stage == 5 && type == 10) {
				str = `<p class="description">基金基本概况 / 七维评价指标 / 可视化解析 / 科学的评价体系 / 投资项目全方位图标解析 / 一键生成报告</p>`
			}

			return str
		},
		diagnoseDesHtml(stage) { //项目诊断的产品描述
			var str = ''
			if (stage == 1) {
				str = `<div>
						<p class="desTitle">
							<i class="iconfont icon-weidu"></i>
							<span>五大维度评分</span>
						</p>
						<ul class="introduce">
							<li>
								<i class="iconfont icon-icon"></i>
								<span>行业竞争力</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>团队实力</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>技术水平</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>风控情况</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>产品-市场匹配度</span>
							</li>
						</ul>
						<p class="desTitle">
							<i class="iconfont icon-bumengongzijiegouduibifenxi"></i>
							<span>支出&收入预测</span>
						</p>
					</div>`
			} else if (stage == 2) {
				str = `<div>
						<p class="desTitle">
							<i class="iconfont icon-See"></i>
							<span>企业成长经营的全面分析</span>
						</p>
						<ul class="introduce">
							<li>
								<i class="iconfont icon-icon"></i>
								<span>行业竞争力</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>团队实力</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>技术水平</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>风控情况</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>产品核心竞争力</span>
							</li>
						</ul>
						<p class="desTitle">
							<i class="iconfont icon-jianyi"></i>
							<span>专业价值诊断和建议</span>
						</p>
					</div>`
			} else if (stage == 3) {
				str = `<div>
						<p class="desTitle">
							<i class="iconfont icon-caozuo-zonghezhenduanpinggu" style="font-size:21px;margin-right:5px;"></i>
							<span>全方位综合诊断</span>
						</p>
						<ul class="introduce">
							<li>
								<i class="iconfont icon-icon"></i>
								<span>行业竞争力</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>团队实力</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>技术水平</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>风控情况</span>
							</li>
							<li>
								<i class="iconfont icon-icon"></i>
								<span>产品核心竞争力</span>
							</li>
						</ul>
						<p class="desTitle">
							<i class="iconfont icon-quote"></i>
							<span>财务状况体检与预测</span>
						</p>
					</div>`
			} else if (stage == 7) {
				str = `<div>
						<ul class="introduce">
							<li style="width:100%;">
								<i class="iconfont icon-zhenduanbaogao" style="font-size:21px;margin-right:5px;position:relative;left:-2px;"></i>
								<span>七维价值诊断</span>
							</li>
							<li style="width:100%;">
								<i class="iconfont icon-jianyi"></i>
								<span>专业价值诊断和建议</span>
							</li>
							<li style="width:100%;">
								<i class="iconfont icon-See"></i>
								<span>企业成长经营的全面分析</span>
							</li>
							<li style="width:100%;">
								<i class="iconfont icon-quote"></i>
								<span>财务状况全方位体检</span>
							</li>
							<li style="width:100%;">
								<i class="iconfont icon-yejibaobiao"></i>
								<span>未来年度业绩及财务预测</span>
							</li>
						</ul>
					</div>`
			} else if (stage == 8) {
				str = `<div>
						<ul class="introduce">
							<li style="width:100%;">
								<i class="iconfont icon-icon"></i>
								<span>六大维度全面体检排查</span>
							</li>
							<li style="width:100%;">
								<i class="iconfont icon-icon"></i>
								<span>健康状况精准把关</span>
							</li>
							<li style="width:100%;">
								<i class="iconfont icon-icon"></i>
								<span>全位守护农企健康</span>
							</li>
							<li style="width:100%;">
								<i class="iconfont icon-icon"></i>
								<span>深度诊断专属方案</span>
							</li>
							<li style="width:100%;">
								<i class="iconfont icon-icon"></i>
								<span>为农企发展保驾护航</span>
							</li>
						</ul>
					</div>`
			}

			return str
		},






	}
}